// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { FunctionComponent, ReactElement, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DefaultLayout } from "../layouts/DefaultLayout";

type NotFoundPagePropsInterface = {};

/**
 * Page to display for 404.
 *
 * @param {NotFoundPagePropsInterface} props - Props injected to the component.
 *
 * @return {React.ReactElement}
 */
export const NotFoundPage: FunctionComponent<NotFoundPagePropsInterface> = (): ReactElement => {
    const navigate = useNavigate();
    const lastLocation = sessionStorage.getItem('lastLocation');

    useEffect(() => {
        if (lastLocation) {
            sessionStorage.removeItem('lastLocation');
        }
    }, []);

    return (
        <DefaultLayout>
            <h3>
                404: Page not found
            </h3>
            <button className="btn primary" style={{ backgroundColor: "orange" }}
                onClick={() => { navigate("/support") }}>Go back to Home</button>
        </DefaultLayout>
    );
};
